import type { AppJob } from "@/lib/api";
import { i18n } from "@/lib/i18n";
import { nl } from "@/lib/i18n/locales/nl";

type JobErrorKind = keyof typeof nl.apps.jobErrors;

function isJobErrorKind(kind: string | null): kind is JobErrorKind {
  return kind !== null && Object.hasOwn(nl.apps.jobErrors, kind);
}

/**
 * What a failed recompute says, in the dashboard's language; with a snapshot
 * on the page, also that it still shows the previous data. The page's banner
 * and the progress dialog say the same.
 */
export function jobErrorText(job: Pick<AppJob, "error">, previousKept: boolean): string {
  const text = i18n.t(`apps.jobErrors.${isJobErrorKind(job.error) ? job.error : "unknown"}`);
  return previousKept ? `${text} ${i18n.t("apps.previousKept")}` : text;
}
